import * as React from "react";
import { useState, useEffect } from "react";
import Button from "./button";
import ReportIcon from "./report-icon";

interface WhitelistSuccessMessageProps {
  className?: string;
  onClose: () => void;
  onClick: () => void;
}

export default function WhitelistSuccessMessage({
  className,
  onClose,
  onClick,
}: WhitelistSuccessMessageProps) {
  return (
    <div className={`${className} `}>
      <div className="relative">
        <header className="relative flex items-center pl-[20px] pr-[20px] pt-[12px] pb-[12px] bg-primary-blue ">
          <div className="text-[28px] text-center">
            <span>INFORMATION</span>
          </div>
          <div
            className="absolute right-[20px] w-[21px] h-[29px] hover:cursor-pointer"
            onClick={onClose}
          >
            <img src="/assets/cancel.svg" alt="cancel" />
          </div>
        </header>
        <main className="flex flex-col justify-center bg-black items-center pt-[15px] pb-[30px] pl-[54px] pr-[54px] text-[24px]">
          <h1 className="text-[30px] text-uppercase text-primary-green">
            your request received
          </h1>
          <p className="text-[24px] pt-[22px] font-spline-sans-mono">
            We'll notify you when you're added to the whitelist.
          </p>
          <div className="relative pt-[10px] flex">
            <ReportIcon className="absolute top-[10px] w-[33px] h-[30px]" />
            <span className="text-[24px] font-spline-sans-mono first-letter:pl-[40px]">
              Submitting your request doesn't guarantee a spot on the whitelist.
            </span>
          </div>

          <div className="pt-[30px] w-full">
            <Button
              className="w-full custom-aspect-320-63 text-[24px] hover:cursor-pointer hover:scale-105 transition-transform duration-300 ease-in-out"
              image="/assets/button.svg"
              text={`OK`}
              onClick={() => {
                onClick();
              }}
            />
          </div>
        </main>
      </div>
    </div>
  );
}
